import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { DataContext } from '../contexts/DataContext';
import InfoCard from '../components/InfoCard/InfoCard';
import EmissionsCard from '../components/EmissionsCard/EmissionsCard';
import RecyclingInfo from '../components/RecyclingInfo/RecyclingInfo';
import { formatDate,formatDateTime } from '../utils/dateUtils';
import { calculateTotalEmissionsAndAbsorption } from '../utils/emissionSegmentUtils';
import { countValidCleaning, countValidRepairs } from '../utils/maintenanceUtils';


function HomePage({ updatedAt }) {
  const { t } = useTranslation(); 

  const { data } = useContext(DataContext);


  const validCleanings = Array.isArray(data.MaintenanceInfo?.cleaning)
    ? data.MaintenanceInfo.cleaning.filter(c =>
        c && typeof c === 'object' &&
        Object.values(c).some(v => Array.isArray(v) ? v.length > 0 : !!v)
      )
    : [];

  const validRepairs = Array.isArray(data.MaintenanceInfo?.repair)
    ? data.MaintenanceInfo.repair.filter(r =>
        r && typeof r === 'object' &&
        Object.values(r).some(v => Array.isArray(v) ? v.length > 0 : !!v)
      )
    : [];

  
  // 最新のクリーニングと修理データを取得
  const latestCleaning = data.MaintenanceInfo?.cleaning?.sort((a, b) => new Date(b.date) - new Date(a.date))[0] || {};
  const latestRepair = data.MaintenanceInfo?.repair?.sort((a, b) => new Date(b.date) - new Date(a.date))[0] || {};

  // co2Emission と co2Absorption の合計を取得
  const { totalEmission, totalAbsorption } = calculateTotalEmissionsAndAbsorption(data);

  return (
<>
<div className="box-left">

      <EmissionsCard
        iconSrc="/images/icon/icon_emissions.svg"
        label={t('home.environmentalImpact')}
        emissionValue={totalEmission.toFixed(2)}
        absorptionValue={totalAbsorption.toFixed(2)}
      />
      
        {/* InfoCard - クリーニング */}
         <InfoCard
          iconSrc="/images/icon/icon_cleaning.svg"
          label={t('home.cleaning')}
          date={formatDate(latestCleaning.date) || '-'}
          count={countValidCleaning(data.MaintenanceInfo?.cleaning)}
        />
        {/* InfoCard - 修理 */}
       <InfoCard
          iconSrc="/images/icon/icon_repair.svg"
          label={t('home.repair')}
          date={formatDate(latestRepair.date) || '-'}
          count={countValidRepairs(data.MaintenanceInfo?.repair)}
        />
</div>   

<div className="box-right">
<RecyclingInfo isMobile={false} />

</div>

<p className="updated-at">{formatDateTime(data.updated)} Updated</p>

</>
      
  );
}

export default HomePage;
